export var RenJSErrors;
(function (RenJSErrors) {
    RenJSErrors["RenVMTransactionNotFound"] = "REN_RENVM_TRANSACTION_NOT_FOUND";
    RenJSErrors["DepositSpentOrNotFound"] = "REN_DEPOSIT_SPENT_OR_NOT_FOUND";
    RenJSErrors["AmountTooSmall"] = "REN_AMOUNT_TOO_SMALL";
})(RenJSErrors || (RenJSErrors = {}));
//# sourceMappingURL=errors.js.map